import React, { Component } from "react";
import {
  Row,
  Alert,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput /* MyCheckbox */ } from "../../Shared/Forms";
import { UploadFile } from "../../Shared/FileUpLoad";
import { dateTimeutils } from "../../../_utils";
import { DatePicker } from "../../Shared/Forms/DateTimePicker";

// import { Link } from "react-router-dom";
// import { ViewEventsAttendees } from "../../../_constants/RouteVariables";

class BannerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false
    };
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    let imageData = data && data.base64Image && data.base64Image.substr(22);

    let newRefineData = {
      title: data.title,
      description: data.description,
      endAt: dateTimeutils.isoDate(data.endAt),
      actionLink: data.actionLink || "",
      base64Image: imageData
    };

    this.props.submitAction(newRefineData);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.resetForm();
    }
  }

  resetForm = () => {
    this.refs.bannerForm.reset();
    if (this.endAt) {
      this.endAt.changeValue(null);
    }
    if (this.imageId) {
      this.imageId.cancelImage();
    }
  };

  reset = () => {
    this.props.reset();
    this.resetForm();
  };

  render() {
    const { canSubmit } = this.state;
    const {
      submitting,
      error,
      hasParams,
      selectedRow,
      isView,
      imageUrl,
      setImageNull,
      fetchingEvent,
      fetchingError,
      isDeleteButton
    } = this.props;

    return (
      <div>
        <Row>
          <Col>
            <Card>
              <CardHeader>{hasParams ? "Edit" : "Create"} Banner Ad</CardHeader>
              <CardBody>
                {error && !error.errors ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                {error && error.errors && error.errors.length ? (
                  <UncontrolledAlert color="danger">
                    {error.errors.map((error, index) => (
                      <p key={index}>{error.message}</p>
                    ))}
                  </UncontrolledAlert>
                ) : null}
                {fetchingError ? (
                  <UncontrolledAlert color="danger">
                    {fetchingError.message}
                  </UncontrolledAlert>
                ) : null}

                {fetchingEvent && (
                  <Alert color="info">
                    <Spinner message="Fetching ads details" />
                  </Alert>
                )}
                <Formsy
                  ref="bannerForm"
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="title"
                    value={selectedRow && hasParams ? selectedRow.title : null}
                    required
                    disabled={submitting || isView || fetchingEvent}
                    title="Title"
                    validations={{
                      minLength: 3,
                      maxLength: 50
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />

                  <TextInput
                    name="description"
                    type="textarea"
                    required
                    value={
                      hasParams && selectedRow ? selectedRow.description : null
                    }
                    disabled={submitting || isView || fetchingEvent}
                    title="Description"
                    validations={{
                      minLength: 5
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />
                  <DatePicker
                    name="endAt"
                    required
                    label="Expiry Date"
                    title="Expiry Date"
                    minDate={new Date()}
                    isTime={true}
                    disabled={submitting || isView || fetchingEvent}
                    defaultValue={hasParams && selectedRow && selectedRow.endAt}
                    innerRef={c => {
                      this.endAt = c;
                    }}
                  />
                  <TextInput
                    name="actionLink"
                    value={
                      selectedRow && hasParams ? selectedRow.actionLink : null
                    }
                    subtitle="
( Example:http://www.example.com )"
                    type="url"
                    disabled={submitting || isView || fetchingEvent}
                    title="Link"
                    validations={{
                      minLength: 3
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed"
                    }}
                  />
                  <UploadFile
                    name="base64Image"
                    type="file"
                    acceptedFormats={"jpg|jpeg|png|gif"}
                    required
                    disabled={submitting || isView || fetchingEvent}
                    value={imageUrl || null}
                    innerRef={c => {
                      this.imageId = c;
                    }}
                    maxSize={1048576}
                    imageUrl={imageUrl && !isDeleteButton ? imageUrl : null} //&& ! isDeleteButton
                    setImageNull={setImageNull}
                    dontShowCancelButton={true}
                    title={isView ? null : "Ad image"}
                    isView={isView}
                    isUpLoading={false}
                  />

                  {!hasParams ? (
                    <Button
                      type="submit"
                      color="primary"
                      disabled={!canSubmit || submitting || isView}
                      className="pp3"
                    >
                      {submitting ? (
                        <Spinner size="sm" />
                      ) : (
                        <span>
                          <MdAdd size={20} />
                          Create
                        </span>
                      )}
                    </Button>
                  ) : null}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.reset()}
                      className="mr-1"
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default BannerForm;
